import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "label", "dropzone"]

  openDialog() {
    this.inputTarget.click()
  }

  select(event) {
    this.updateLabel(event.target.files)
  }

  dragover(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("border-[#3182F6]", "bg-blue-50")
  }

  dragleave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-[#3182F6]", "bg-blue-50")
  }

  drop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-[#3182F6]", "bg-blue-50")

    const files = event.dataTransfer.files
    if (files.length > 0 && files[0].name.endsWith('.csv')) {
      this.inputTarget.files = files
      this.updateLabel(files)
    } else {
      this.labelTarget.textContent = "CSV 파일만 업로드할 수 있습니다"
      this.labelTarget.classList.add("text-red-500")
    }
  }

  updateLabel(files) {
    if (files.length > 0) {
      this.labelTarget.textContent = files[0].name
      this.labelTarget.classList.remove("text-red-500")
      this.labelTarget.classList.add("text-[#3182F6]", "font-medium")
    }
  }
}
